<template>
  <div class="mit-landing-page mit-page">
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <div class="pa-2">
              <center>
                <h3 class="pb-2">Welcome to CSAIL spaces</h3>
                <p>My CSAIL is a place to explore csail spaces.</p>
              </center>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
              <v-btn link @click="login">Sign in</v-btn>
          </v-col>
          <!-- <v-col v-if="resetByEmail" cols="12" class="d-flex justify-center align-center">
              <a href="/password/forgot">Forgot Password</a>
          </v-col> -->
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitLandingPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
       login() {
         window.location.href = '/auth/provider';
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
